// extracted by mini-css-extract-plugin
module.exports = {"list":"style__list__zCep2","delete":"style__delete__33iTu"};